(function () {
  'use strict';

  const angular = window.angular;

  GlobalUsers.$inject = ['$uibModal', '$state', 'LoopBackAuth', 'AppUtils'];

  angular.module('app').component('globalConfigs', {
    template:'<div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"><strong translate>entities.user.superAdmin.modelNamePl</strong></h2></header><div class="panel-body no-padding"><users-table users="ctrl.superAdmins" time-zones="ctrl.timeZones" countries="ctrl.countries" user-type="\'SuperAdmin\'"></users-table></div></div><div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"><strong translate>entities.user.supportAdmin.modelNamePl</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><button class="btn btn-primary" ng-click="ctrl.showCreateUserModal(\'SupportAdmin\',undefined)"><i class="fas fa-plus"></i></button></div></div></header><div class="panel-body no-padding"><users-table users="ctrl.supportAdmins" time-zones="undefined" countries="undefined" user-type="\'SupportAdmin\'" edit="true" remove="true" vars="ctrl.vars"></users-table></div></div>',
    controller: GlobalUsers,
    controllerAs: 'ctrl',
    bindings: {
      vars: '<',
      superAdmins: '<',
      supportAdmins: '<',
    },
  });

  function GlobalUsers($uibModal, $state, LoopBackAuth, utils) {
    let vm = this;

    vm.$onInit = function () {
      vm.showCreateUserModal = showCreateUserModal;
    };
    function showCreateUserModal() {
      let instance = $uibModal.open({
        animation: false,
        backdrop: 'static',
        bindToController: true,
        component: 'supportAdminForm',
        size: 'lg',
        resolve: {
          vars: function () {
            return vm.vars;
          },
          user: function () {
            return {};
          },
        },
      });

      instance.result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
})();
